import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AxiosInstance from "../Home/AxiosInstance";

const AddJob = () => {
  const [formData, setFormData] = useState({
    role: "",
    job_description: "",
    skills: "",
    good_to_have_skills: "",
    salary: "",
    experience: "",
    location: "",
    department: "",
    education: "",
    work_mode: "",
    employment_type: "",
    vacancies: "",
    apply_by: "",
    start_date: "",
    end_date: "",
    benefits: "",
    status: "Open",
  });

  const [educationOptions, setEducationOptions] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const userId = localStorage.getItem("userId");
  const companyId = localStorage.getItem("companyId");

  useEffect(() => {
    AxiosInstance.get("companies/educations/")
      .then((res) => {
        setEducationOptions(Array.isArray(res.data) ? res.data : []);
      })
      .catch(() => setEducationOptions([]));

    AxiosInstance.get("companies/departments/")
      .then((res) => {
        setDepartmentOptions(Array.isArray(res.data) ? res.data : []);
      })
      .catch(() => setDepartmentOptions([]));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setIsLoading(true);

    if (!userId || !companyId) {
      setErrorMessage("User ID or Company ID not found.");
      setIsLoading(false);
      return;
    }

    const newJob = {
      ...formData,
      user: parseInt(userId),
      company: parseInt(companyId),
    };

    try {
      const res = await AxiosInstance.post("companies/job/", newJob);
      if (res.status === 201) {
        alert("Job added successfully!");
        navigate("/user-profile");
      } else {
        setErrorMessage("Failed to add job.");
      }
    } catch (error) {
      console.error("Error adding job:", error);
      setErrorMessage("Something went wrong. Please check the form.");
    } finally {
      setIsLoading(false);
    }
  };

  const closeModal = () => {
    navigate("/user-profile");
  };

  return (
    <>
      <div className="modal-backdrop fade show"></div>
      <div
        className="modal d-block"
        tabIndex="-1"
        aria-modal="true"
        role="dialog"
        style={{ backgroundColor: "rgba(0,0,0,0.3)" }}
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content" style={{ maxHeight: "90vh" }}>
            <div className="modal-header">
              <h5 className="modal-title">Add Job</h5>
            </div>

            <div
              className="modal-body overflow-auto"
              style={{ maxHeight: "65vh", paddingRight: "15px" }}
            >
              {errorMessage && (
                <div className="alert alert-danger">{errorMessage}</div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Role:</label>
                    <input
                      type="text"
                      className="form-control"
                      name="role"
                      value={formData.role}
                      onChange={handleChange}
                      required
                      disabled={isLoading}
                    />
                  </div>

                  <div className="mb-3 col-md-6">
                    <label className="form-label">Location:</label>
                    <input
                      type="text"
                      className="form-control"
                      name="location"
                      value={formData.location}
                      onChange={handleChange}
                      required
                      disabled={isLoading}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Salary:</label>
                    <input
                      type="text"
                      className="form-control"
                      name="salary"
                      value={formData.salary}
                      onChange={handleChange}
                      required
                      disabled={isLoading}
                    />
                  </div>

                  <div className="mb-3 col-md-6">
                    <label className="form-label">Experience:</label>
                    <input
                      type="text"
                      className="form-control"
                      name="experience"
                      value={formData.experience}
                      onChange={handleChange}
                      required
                      disabled={isLoading}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Department:</label>
                    <select
                      className="form-select"
                      name="department"
                      value={formData.department}
                      onChange={handleChange}
                      required
                      disabled={isLoading}
                    >
                      <option value="">Select department</option>
                      {departmentOptions.map((dept) => (
                        <option
                          key={dept.department_id}
                          value={dept.department_name}
                        >
                          {dept.department_name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="mb-3 col-md-6">
                    <label className="form-label">Education:</label>
                    <select
                      className="form-select"
                      name="education"
                      value={formData.education}
                      onChange={handleChange}
                      required
                      disabled={isLoading}
                    >
                      <option value="">Select education</option>
                      {educationOptions.map((edu) => (
                        <option
                          key={edu.education_id}
                          value={edu.qualification}
                        >
                          {edu.qualification}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">Job Description:</label>
                  <textarea
                    className="form-control"
                    name="job_description"
                    value={formData.job_description}
                    onChange={handleChange}
                    rows="3"
                    required
                    disabled={isLoading}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Skills:</label>
                  <textarea
                    className="form-control"
                    name="skills"
                    value={formData.skills}
                    onChange={handleChange}
                    rows="3"
                    required
                    disabled={isLoading}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Good to Have Skills:</label>
                  <textarea
                    className="form-control"
                    name="good_to_have_skills"
                    value={formData.good_to_have_skills}
                    onChange={handleChange}
                    rows="2"
                    disabled={isLoading}
                  />
                </div>

                <div className="row">
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Vacancies:</label>
                    <input
                      type="number"
                      className="form-control"
                      name="vacancies"
                      value={formData.vacancies}
                      onChange={handleChange}
                      required
                      disabled={isLoading}
                    />
                  </div>

                  <div className="mb-3 col-md-6">
                    <label className="form-label">Apply By:</label>
                    <input
                      type="date"
                      className="form-control"
                      name="apply_by"
                      value={formData.apply_by}
                      onChange={handleChange}
                      required
                      disabled={isLoading}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Start Date:</label>
                    <input
                      type="date"
                      className="form-control"
                      name="start_date"
                      value={formData.start_date}
                      onChange={handleChange}
                      required
                      disabled={isLoading}
                    />
                  </div>

                  <div className="mb-3 col-md-6">
                    <label className="form-label">End Date:</label>
                    <input
                      type="date"
                      className="form-control"
                      name="end_date"
                      value={formData.end_date}
                      onChange={handleChange}
                      disabled={isLoading}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Work Mode:</label>
                    <select
                      className="form-select"
                      name="work_mode"
                      value={formData.work_mode}
                      onChange={handleChange}
                      disabled={isLoading}
                      required
                    >
                      <option value="" disabled>
                        Select Work Mode
                      </option>
                      <option value="Remote">Remote</option>
                      <option value="Hybrid">Hybrid</option>
                      <option value="Onsite">Onsite</option>
                    </select>
                  </div>

                  <div className="mb-3 col-md-6">
                    <label className="form-label">Employment Type:</label>
                    <select
                      className="form-select"
                      name="employment_type"
                      value={formData.employment_type}
                      onChange={handleChange}
                      disabled={isLoading}
                      required
                    >
                      <option value="" disabled>
                        Select Type
                      </option>
                      <option value="Full Time">Full Time</option>
                      <option value="Part Time">Part Time</option>
                      <option value="Contract">Contract</option>
                    </select>
                  </div>
                </div>

                <div className="row">
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Status:</label>
                    <select
                      className="form-select"
                      name="status"
                      value={formData.status}
                      onChange={handleChange}
                      disabled={isLoading}
                      required
                    >
                      <option value="Open">Open</option>
                      <option value="Closed">Closed</option>
                      <option value="Cancelled">Cancelled</option>
                    </select>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">Benefits:</label>
                  <textarea
                    className="form-control"
                    name="benefits"
                    value={formData.benefits}
                    onChange={handleChange}
                    rows="2"
                    disabled={isLoading}
                  />
                </div>

                <div className="d-flex justify-content-end mt-3">
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    onClick={closeModal}
                    disabled={isLoading}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={isLoading}
                  >
                    {isLoading ? "Saving..." : "Save Job"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddJob;
